import React, { Component } from 'react';
import withAuth from '../auth_components/js/withAuth';
import Navbar from '../Components/Navbar';
import Gallery from '../Components/Gallery/Gallery';


class GalleryAwardContainer extends Component {
    constructor(props) {
        super(props);
        let user = JSON.parse(localStorage.getItem('user')).user;

        this.state = {
            apikey: user.apikey,
            username: user.email,
            role: user.role,
        };
    }

    render() {
        return (
            <div>
                <Navbar history={this.props.history} />
                <div className="main-body" style={{ padding: 20 }}>
                    <h2 style={{ marginBottom: 20 }}>Awards & Achievements</h2>
                    <p style={{ color: '#666', marginBottom: 20 }}>
                        Upload images with captions. They appear in the
                        "Awards &amp; Achievements" carousel on the home page.
                    </p>

                    <Gallery
                        type="AWARD"
                        dept="COLLEGE"
                        history={this.props.history}
                        apikey={this.state.apikey}
                        username={this.state.username}
                    />
                </div>
            </div>
        );
    }
}

export default withAuth(GalleryAwardContainer);



// WEBPACK FOOTER //
// ./src/Containers/GalleryAwardContainer.js